import { render, staticRenderFns } from "./FavoritesComp.vue?vue&type=template&id=4974327c&scoped=true"
import script from "./FavoritesComp.vue?vue&type=script&lang=js"
export * from "./FavoritesComp.vue?vue&type=script&lang=js"
import style0 from "./FavoritesComp.vue?vue&type=style&index=0&id=4974327c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4974327c",
  null
  
)

export default component.exports